let amaModulesCache: any = null;

export default function getModules() {
  if (amaModulesCache) {
    return amaModulesCache;
  }
  
  amaModulesCache = {
      useLoadDMByAdsLib: true,
      adTags: {},
      useLimitedAds: true,
      useStats: true,
      useGLazyLoad: ['responsive_1', 'top_ad'],
    };
 
  return amaModulesCache;
}
  